module.exports = __webpack_public_path__ + "static/media/23.3f280423.jpg";